<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="500px"
            :before-close="handleClose">
            <p style="font-size: 16px;line-height:30px">{{ $t('Order.List.Components.AddressWrongPayDialog.Tips1') }}:</p>
            <div v-for="item in orderIds.filter(e=>e.status === 1)" :key="item.kkOrderId" class="orderId">
                {{ $t('Order.List.Components.AddressWrongPayDialog.OrderID') }}: {{item.kkOrderId}}
            </div>
            <span slot="footer" class="f-c">
                <!-- <el-button @click="dialogVisible = false" style="width:216px;height:46px">Complete information</el-button> -->
                <el-button type="primary" @click="continueToPay" style="width:216px;height:46px">{{ $t('Order.List.Components.AddressWrongPayDialog.ContinueToPay') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      orderIds: [],
      totalAmountNormal: 0
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.orderIdsWrong = []
    },
    show(info) {
      this.orderIds = info.ordersWhetherToPayVos
      this.totalAmountNormal = info.totalAmount
      this.dialogVisible = true
    },
    continueToPay() {
      this.$emit('continueToPay', { orderIds: this.orderIds.filter(e => e.status === 0), totalAmount: this.totalAmountNormal })
    }
  }
}
</script>

<style lang="scss" scoped>
.orderId{
    color: #99C41C;
    font-size: 14px;
    line-height: 30px;
}
</style>
